// extracted by mini-css-extract-plugin
module.exports = {"CategoriesLinks":"CategoriesLinks_CategoriesLinks__2Lqcw"};